import React from "react";
import { Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { TemplateRuleRow } from "../../RulesModal.types";

interface ActionBtnsCellRendererProps {
  data: TemplateRuleRow;
  mode: |"create" | "view" | "edit";
  onEdit: (row: TemplateRuleRow) => void;
  onDelete: (row: TemplateRuleRow) => void;
}

const ActionBtnsCellRenderer: React.FC<ActionBtnsCellRendererProps> = ({ mode, data, onEdit, onDelete }) => {
  const isViewMode = mode === "view";

  const handleEditClick = () => {
    onEdit(data);
  };

  const handleDeleteClick = () => {
    onDelete(data);
  };

  return (
    <div style={{ display: "flex" }}>
      <OverlayTrigger placement="bottom" overlay={<Tooltip>Edit rule</Tooltip>}>
        <Button className="icon-button" onClick={handleEditClick}>
          <Icon.PencilSquare />
        </Button>
      </OverlayTrigger>
      <OverlayTrigger placement="bottom" overlay={<Tooltip>Delete rule</Tooltip>}>
        <Button
          className="icon-button"
          onClick={() => !isViewMode && handleDeleteClick()}
          disabled={isViewMode}
        >
          <Icon.Trash
            style={{
              color: isViewMode ? "#ccc" : "red"
            }}
          />
        </Button>
      </OverlayTrigger>
    </div>
  );
};

export default ActionBtnsCellRenderer;
